import { create } from 'zustand'
import { formularioCategoriaOrdenSlice } from './slices/categoriaOrdenSlice'

const useCategoriaOrdenStore = create((set,get) => ({
    isLoading: true,
    sucursalesOrden: [],
    sucursales:[],
    categoriasOrden:[],
    categoriasOrdenTemp:[],
    handleSucursales: (e) => {
      set({ sucursalesOrden: [e] })
      set({ categoriasOrdenTemp: get().categoriasOrden })
    },
    handleCategoriasOrden: (e) => {
      // console.log('categoriasOrdenTemp',e);
      set({ categoriasOrdenTemp: e })
    },
    ...formularioCategoriaOrdenSlice(set,get),
    iniciar: async() => {
        await get().obtenerCategoriaOrden();
    },
    limpiar: () => {
      set({
        isLoading: true,
        platillos: [],
        multiImagenes: []
      })
    }
}))
  
export default useCategoriaOrdenStore